module.exports = __webpack_public_path__ + "static/media/transaction_preview.d58b1b56.PNG";